import FontSize from "%/dynamic-component-editor/options/font-size";
import { themeStructure } from "@vcl";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import normalizeFontSizeStyleValue from "%/dynamic-component-editor/helpers/font-size-style-value";

export default class CountSize extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {
    let suffix = "px";
    const selectOptions = [];
    if (themeId !== undefined) {
      themeStructure.size.font.forEach(size => {
        if (this.deprecatedFontSizeAliases.includes(size)) {
          return;
        }

        let pxValue = BaseOption._getStyleValuePropertiesFromTheme("size.font", themeId)[size];

        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pxValue,
        });

        if (optionValues["default.font-size"] === size || optionValues["default.font-size"]?.value === size) {
          suffix = pxValue;
        }
      });

      const fontSizeInstance = new FontSize();
      const currentFontSizesObject = fontSizeInstance.getValueOrDefault(optionValues);
      const currentFontSize = currentFontSizesObject["default.font-size"];
      const currentHoverFontSize = currentFontSizesObject["hover.font-size"];

      if (this.isCurrentSelectionDeprecated(currentFontSize, currentHoverFontSize)) {
        const sizeKey = currentFontSize.value;
        selectOptions.push({
          value: sizeKey,
          label: camelToTitleCase(sizeKey),
          secondaryLabel: BaseOption._getStyleValuePropertiesFromTheme("size.font", themeId)[sizeKey],
        });
      }
    }

    return {
      label: "Count Size",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        showAllResultsOnClick: true,
        allowCustomValue: true,
        suffix: suffix,
        items: selectOptions,
        manualUpdate: true,
        findSuffix: modelValue => {
          if (!modelValue.secondaryLabel && themeStructure.size.font.includes(modelValue.value)) {
            return BaseOption._getStyleValuePropertiesFromTheme("size.font", themeId)[modelValue.value];
          }

          if (!modelValue.secondaryLabel) {
            return "px";
          }

          return modelValue.secondaryLabel;
        },
        sideEffect: (value, emitUpdate) => {
          if (Number.isFinite(parseInt(value.value))) {
            emitUpdate({ source: "custom", value: value.value });
            return;
          }

          const newValue = { source: "theme.font", value: value.value };
          emitUpdate(newValue);
        },
      },
    };
  };

  static defaultValue = {
    source: "theme.font",
    value: "standard",
  };

  static deprecatedFontSizeAliases = [
    "footnote",
    "verySmall",
    "extraExtraLarge",
    "displayVerySmall",
    "displaySmall",
    "displayMedium",
    "displayLarge",
  ];

  static isCurrentSelectionDeprecated(currentFontSize, currentHoverFontSize) {
    const isHoverFontSizeDeprecated = this.deprecatedFontSizeAliases.includes(currentHoverFontSize.value);
    const isFontSizeDeprecated = this.deprecatedFontSizeAliases.includes(currentFontSize.value);
    return isFontSizeDeprecated || isHoverFontSizeDeprecated;
  }

  static convertConfigValueToCompiledValue(configValue, themeId) {
    const value = BaseOption._getStyleValuePropertiesFromTheme("size.font", themeId)[configValue.value || configValue];

    if (value) {
      return value;
    }

    if (Number.isFinite(configValue.value)) {
      return configValue.value + "px";
    }

    if (configValue.source === "custom") {
      return normalizeFontSizeStyleValue(configValue.value, { element: "ActionElement", option: "count-size" });
    }

    return normalizeFontSizeStyleValue(
      typeof configValue === "object" ? configValue?.value : configValue,
      { element: "ActionElement", option: "count-size" },
    );
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
